// extracted by mini-css-extract-plugin
export default {"dialogBackdrop":"PromotionDialog_dialogBackdrop__V8Qxm","dialog":"PromotionDialog_dialog__MYd2G"};